<template>
  <v-data-table
    :headers="headers"
    :items="filteredManufacturers"
    sort-by="name"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-text-field
          label="Busca"
          v-model="filter"
          outlined
          dense
          hide-details
          clearable
          append-icon="eva-search-outline"
        />

        <v-spacer></v-spacer>

        <v-dialog v-model="dialog" max-width="500px" @click:outside="close">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="light-blue" dark v-bind="attrs" v-on="on">
              Nova prótese
            </v-btn>
          </template>

          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container fluid>
                <v-row dense>
                  <v-col cols="12">
                    <v-text-field
                      outlined
                      dense
                      hide-details
                      v-model="editedItem.name"
                      label="Nome"
                    />
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12">
                    <v-select
                      outlined
                      dense
                      hide-details
                      v-model="editedItem.manufacturer"
                      label="Fabricante"
                      :items="prosthesisManufacturers"
                      item-text="name"
                      return-object
                    />
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12">
                    <v-select
                      outlined
                      dense
                      hide-details
                      v-model="editedItem.prosthesisType"
                      label="Modelo"
                      :items="prosthesisTypes"
                      item-text="name"
                      return-object
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">
                Cancelar
              </v-btn>

              <v-btn color="blue darken-1" text @click="save"> Salvar </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
      <authorization
        permissionKey="configuration_prosthesis"
        can="save"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small class="mr-2" @click="editItem(item)">
          eva-edit-outline
        </v-icon>
      </authorization>

      <authorization
        permissionKey="configuration_prosthesis"
        can="delete"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small @click="deleteItem(item)">
          eva-trash-outline
        </v-icon>
      </authorization>
    </template>

    <template v-slot:no-data>
      <v-alert color="orange" outlined text type="info">
        Não há próteses cadastradas
      </v-alert>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "ProsthesesConfig",
  apollo: {
    prostheses: {
      query: require("@/graphql/prosthesis/prostheses.gql"),
      pollInterval: 20000,
    },
    prosthesisTypes: {
      query: require("@/graphql/prosthesis/prosthesis_types.gql"),
    },
    prosthesisManufacturers: {
      query: require("@/graphql/prosthesis/prosthesis_manufacturers.gql"),
    },
  },
  data() {
    return {
      dialog: null,
      editedItem: {},
      editedIndex: -1,
      filter: "",
      headers: [
        { text: "Nome", value: "name" },
        { text: "Fabricante", value: "manufacturer.name" },
        { text: "Modelo", value: "prosthesisType.name" },
        { text: "Ações", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  computed: {
    filteredManufacturers() {
      let prostheses = this.prostheses;

      if (this.filter) {
        prostheses = this.lodash.filter(
          prostheses,
          function (e) {
            return e.name
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .includes(
                this.filter
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
              );
          }.bind(this)
        );
      }

      return prostheses;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Nova prótese" : "Editar prótese";
    },
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.filteredManufacturers.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      if (confirm("Você realmente deseja deletar esse prótese?")) {
        this.apolloMutate({
          mutation: require("@/graphql/prosthesis/delete_prosthesis.gql"),
          variables: {
            prosthesisId: item.id,
          },
        }).then(() => {
          this.refreshList();

          this.$store.dispatch("createNotification", {
            message: "Prótese deletado com sucesso.",
            type: "success",
          });
        });
      }
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      this.apolloMutate({
        mutation: require("@/graphql/prosthesis/save_prosthesis.gql"),
        variables: {
          prosthesisId: this.lodash.get(this.editedItem, "id", ""),
          name: this.editedItem.name,
          prosthesisTypeId: this.editedItem.prosthesisType.id,
          prosthesisManufacturerId: this.editedItem.manufacturer.id,
        },
      }).then(() => {
        this.refreshList();

        this.$store.dispatch("createNotification", {
          message: "Cadastro salvo com sucesso.",
          type: "success",
        });
      });

      this.close();
    },
    refreshList() {
      return this.$apollo.queries.prostheses.refetch();
    },
  },
};
</script>

<style lang="scss" scoped></style>
